import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class UnityChartService extends Subject<any>{

    private _index: number;
    private _level: number;

    constructor() {
        super();
        this._index = 0;
        this._level = 0;
    }

    public drillDown(index: number, level: number) {
        this._index = index;
        this._level = level;
    }

    public get index(): number {
        return this._index;
    }

    public get level(): number {
        return this._level;
    }

    public next(value?: any) {
        if (!value) {
            value = {
                index: this.index,
                level: this.level
            }
        }
        super.next(value);
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/components/unity-chart/unity-chart.service.ts